import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { DownloadProvider } from "@/lib/download";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import RateSection from "@/components/landing/RateSection";
import HowItWorks from "@/components/landing/HowItWorks";
import WhyCoinAdda from "@/components/landing/WhyCoinAdda";
import AppPromo from "@/components/landing/AppPromo";
import TrustSection from "@/components/landing/TrustSection";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import Footer from "@/components/landing/Footer";
import DownloadDialog from "@/components/landing/DownloadDialog";

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <DownloadProvider>
      <div className="min-h-screen bg-[#050B14] font-sans text-slate-50 antialiased selection:bg-[#00F5A0] selection:text-[#050B14]">
        <div className="grain-overlay" aria-hidden />
        <Header />
        <main>
          <Hero />
          <RateSection />
          <HowItWorks />
          <WhyCoinAdda />
          <AppPromo />
          <TrustSection />
          <Faq />
          <FinalCta />
        </main>
        <Footer />
        <DownloadDialog />
      </div>
    </DownloadProvider>
  );
}
